module.exports = __webpack_public_path__ + "img/Ventas02.5c95eabb.png";